import React, { useEffect, useState } from "react";

const LOGO_URL = "/images/logo.png";

/** Match PublicHeader / Homepage stacked layout. */
const FOOTER_STACK_BREAKPOINT_PX = 1024;

const styles = {
  footer: {
    background: "#020617",
    color: "#cbd5e1",
    padding: "60px 0 40px",
    borderTop: "1px solid #0f172a",
    marginTop: "10px",
  },
  footerNarrow: { padding: "44px 0 36px" },
  container: { maxWidth: "1100px", margin: "0 auto", padding: "0 20px" },
  footerGrid: {
    display: "grid",
    gridTemplateColumns: "1.6fr 1fr 1fr",
    gap: "46px",
    alignItems: "flex-start",
  },
  footerGridStacked: {
    gridTemplateColumns: "1fr",
    gap: "36px",
  },
  footerCol: { display: "flex", flexDirection: "column", gap: "12px" },
  footerBrandGroup: { display: "flex", alignItems: "center", gap: "10px" },
  footerBrandText: { color: "#e5e7eb", fontSize: "19px", fontWeight: 700 },
  footerTitle: {
    color: "#f9fafb",
    fontSize: "13px",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.15em",
    marginBottom: "4px",
  },
  footerText: { fontSize: "13px", margin: 0, color: "#94a3b8", lineHeight: 1.5 },
  footerLink: { fontSize: "13px", color: "#60a5fa", textDecoration: "none", fontWeight: 600 },
  footerLogoImg: { height: "34px", width: "auto", display: "block" },
};

export default function PublicFooter() {
  const [isNarrow, setIsNarrow] = useState(
    () => typeof window !== "undefined" && window.innerWidth < FOOTER_STACK_BREAKPOINT_PX
  );

  useEffect(() => {
    const onResize = () => setIsNarrow(window.innerWidth < FOOTER_STACK_BREAKPOINT_PX);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <footer style={{ ...styles.footer, ...(isNarrow ? styles.footerNarrow : {}) }}>
      <div style={styles.container}>
        <div style={{ ...styles.footerGrid, ...(isNarrow ? styles.footerGridStacked : {}) }}>
          <div style={styles.footerCol}>
            <div style={{ ...styles.footerBrandGroup, ...(isNarrow ? { alignItems: "flex-start", flexWrap: "wrap" } : {}) }}>
              <img src={LOGO_URL} alt="True Education logo" style={styles.footerLogoImg} />
              <span style={{ ...styles.footerBrandText, ...(isNarrow ? { lineHeight: 1.25 } : {}) }}>True Education Cumming</span>
            </div>
            <p
              style={{
                ...styles.footerText,
                marginTop: "6px",
                maxWidth: isNarrow ? "none" : "360px",
              }}
            >
              Empowering students with personalized tutoring, test prep, and expert college counseling—serving
              families in Cumming and beyond.
            </p>
          </div>

          <div style={styles.footerCol}>
            <div style={styles.footerTitle}>Location</div>
            <p style={styles.footerText}>580 Peachtree Pkwy #102</p>
            <p style={styles.footerText}>Cumming, GA 30041</p>
            <a
              href="https://maps.app.goo.gl/pDQFVVqTHJ5wranW7"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.footerLink}
            >
              View on map →
            </a>
          </div>

          <div style={styles.footerCol}>
            <div style={styles.footerTitle}>Contact Us</div>
            <a href="mailto:cumming@trueeducation.com" style={styles.footerLink}>
              cumming@trueeducation.com
            </a>
            <p style={styles.footerText}>(470) 470-4715</p>
            <p style={styles.footerText}>Call or email us to learn more or schedule a free consultation.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
